/**
 * Transform Phoenix DSP Ad Stats API response to banner list stats format
 * @param {Array} items - Array of daily stats from API
 * @returns {Object} - Transformed stats grouped by banner ID
 */
export default function transformAdStatsToTableFormat(items) {
  if (!items || !Array.isArray(items)) {
    return {}
  }

  // Get today and yesterday in UTC to match API date format
  const now = new Date()
  const todayYear = now.getUTCFullYear()
  const todayMonth = String(now.getUTCMonth() + 1).padStart(2, '0')
  const todayDay = String(now.getUTCDate()).padStart(2, '0')
  const today = `${todayYear}-${todayMonth}-${todayDay}`

  const yesterdayDate = new Date(Date.UTC(todayYear, now.getUTCMonth(), now.getUTCDate() - 1))
  const yesterdayYear = yesterdayDate.getUTCFullYear()
  const yesterdayMonth = String(yesterdayDate.getUTCMonth() + 1).padStart(2, '0')
  const yesterdayDay = String(yesterdayDate.getUTCDate()).padStart(2, '0')
  const yesterday = `${yesterdayYear}-${yesterdayMonth}-${yesterdayDay}`

  const statsByBanner = {}

  items.forEach(item => {
    const bannerId = item.ad_id
    // Parse UTC date string and format to YYYY-MM-DD in UTC
    const itemDateObj = new Date(item.date)
    // Use UTC components to ensure correct date comparison
    const itemYear = itemDateObj.getUTCFullYear()
    const itemMonth = String(itemDateObj.getUTCMonth() + 1).padStart(2, '0')
    const itemDay = String(itemDateObj.getUTCDate()).padStart(2, '0')
    const itemDate = `${itemYear}-${itemMonth}-${itemDay}`

    if (!statsByBanner[bannerId]) {
      statsByBanner[bannerId] = {
        show: 0,
        click: 0,
        pixel: 0, // conversions - not in new API, set to 0
        amount: 0,
        today: {
          show: 0,
          click: 0,
          pixel: 0,
          amount: 0,
        },
        yesterday: {
          show: 0,
          click: 0,
          pixel: 0,
          amount: 0,
        },
      }
    }

    // Add to total for period
    statsByBanner[bannerId].show += item.impressions || 0
    statsByBanner[bannerId].click += item.clicks || 0
    statsByBanner[bannerId].amount += item.spent || 0

    // Add to today stats
    if (itemDate === today) {
      statsByBanner[bannerId].today.show += item.impressions || 0
      statsByBanner[bannerId].today.click += item.clicks || 0
      statsByBanner[bannerId].today.amount += item.spent || 0
    }

    // Add to yesterday stats
    if (itemDate === yesterday) {
      statsByBanner[bannerId].yesterday.show += item.impressions || 0
      statsByBanner[bannerId].yesterday.click += item.clicks || 0
      statsByBanner[bannerId].yesterday.amount += item.spent || 0
    }
  })

  return statsByBanner
}
